import { createContext, ReactNode, useContext } from 'react'
import { createPortal } from 'react-dom'

export const PageFooterPortalContext = createContext<HTMLElement | null>(null)

export const PageFooter = ({ children, className, placement = 'local' }: {
    children?: ReactNode
    className?: string
    placement?: 'local' | 'page'
}) => {
    const target = useContext(PageFooterPortalContext)

    return placement === 'page' && target
        ? createPortal(children, target)
        : <div className={className}>{children}</div>
}
